module.exports = __webpack_public_path__ + "img/nilai-contoh.6d462883.jpg";